import { Badge } from '@/components/ui/Badge';
import { prefixLogicChipLabel } from '@/api/ruleRecommendations';
import type { RuleLogicChip } from '@/types/ruleRecommendations';

export function RuleLogicChips({
  chips,
  rangeLabel,
}: {
  chips: RuleLogicChip[];
  rangeLabel: string;
}) {
  if (!chips.length) return null;
  return (
    <ul className="flex min-w-0 flex-wrap gap-1.5">
      {chips.map((chip) => (
        <li key={chip.key}>
          <Badge
            variant="brand"
            className="normal-case tracking-normal"
            title={chip.tooltip}
          >
            {prefixLogicChipLabel(chip.label, rangeLabel)}
          </Badge>
        </li>
      ))}
    </ul>
  );
}
